export const centroids = [
  "sacrum_C",
  "vertebrae_L5_C",
  "vertebrae_L4_C",
  "vertebrae_L3_C",
  "vertebrae_L2_C",
  "vertebrae_L1_C",
  "vertebrae_T12_C",
  "vertebrae_T11_C",
  "vertebrae_T10_C",
  "vertebrae_T9_C",
  "vertebrae_T8_C",
  "vertebrae_T7_C",
  "vertebrae_T6_C",
  "vertebrae_T5_C",
  "vertebrae_T4_C",
  "vertebrae_T3_C",
  "vertebrae_T2_C",
  "vertebrae_T1_C",
  "vertebrae_C7_C",
  "vertebrae_C6_C",
  "vertebrae_C5_C",
  "vertebrae_C4_C",
  "vertebrae_C3_C",
  "vertebrae_C2_C",
  "vertebrae_C1_C",
];

export const VertebraEnum = Object.freeze({
  // Lumbar
  L1: "L1",
  L2: "L2",
  L3: "L3",
  L4: "L4",
  L5: "L5",
  L6: "L6",

  // Thoracic
  T1: "T1",
  T2: "T2",
  T3: "T3",
  T4: "T4",
  T5: "T5",
  T6: "T6",
  T7: "T7",
  T8: "T8",
  T9: "T9",
  T10: "T10",
  T11: "T11",
  T12: "T12",
  T13: "T13",

  // Cervical
  C1: "C1",
  C2: "C2",
  C3: "C3",
  C4: "C4",
  C5: "C5",
  C6: "C6",
  C7: "C7",
});

export const VertebraEnumAnatomicalOrder = Object.freeze({
  // Cervical (top to bottom)
  C1: "C1",
  C2: "C2",
  C3: "C3",
  C4: "C4",
  C5: "C5",
  C6: "C6",
  C7: "C7",

  // Thoracic (top to bottom)
  T1: "T1",
  T2: "T2",
  T3: "T3",
  T4: "T4",
  T5: "T5",
  T6: "T6",
  T7: "T7",
  T8: "T8",
  T9: "T9",
  T10: "T10",
  T11: "T11",
  T12: "T12",
  T13: "T13",

  // Lumbar (top to bottom)
  L1: "L1",
  L2: "L2",
  L3: "L3",
  L4: "L4",
  L5: "L5",
});

export const vertebraGroups = {
  LUMBAR: ["L1", "L2", "L3", "L4", "L5"],
  THORACIC: [
    "T1",
    "T2",
    "T3",
    "T4",
    "T5",
    "T6",
    "T7",
    "T8",
    "T9",
    "T10",
    "T11",
    "T12",
  ],
  CERVICAL: ["C7"],
  SACRUM: ["S1", "S2"],
};

export const intervertebralDisks = {
  LUMBAR: ["L5-S1", "L4-L5", "L3-L4", "L2-L3", "L1-L2"],
  LUMBARL6: ["L6-S1", "L5-L6", "L4-L5", "L3-L4", "L2-L3", "L1-L2"],
  THORACIC: [
    "T11-T12",
    "T10-T11",
    "T9-T10",
    "T8-T9",
    "T7-T8",
    "T6-T7",
    "T5-T6",
    "T4-T5",
    "T3-T4",
    "T2-T3",
    "T1-T2",
  ],
  THORACICL6: [
    "T12-T13",
    "T11-T12",
    "T10-T11",
    "T9-T10",
    "T8-T9",
    "T7-T8",
    "T6-T7",
    "T5-T6",
    "T4-T5",
    "T3-T4",
    "T2-T3",
    "T1-T2",
  ],
};

export const VertebralRegionsEnum = Object.freeze({
  LUMBAR: "LUMBAR",
  THORACIC: "THORACIC",
  CERVICAL: "CERVICAL",
  SACRUM: "SACRUM",
});
export const PCOVertebraLabels = Object.freeze({
  C7: "C7/T1",
  T1: "T1/T2",
  T2: "T2/T3",
  T3: "T3/T4",
  T4: "T4/T5",
  T5: "T5/T6",
  T6: "T6/T7",
  T7: "T7/T8",
  T8: "T8/T9",
  T9: "T9/T10",
  T10: "T10/T11",
  T11: "T11/T12",
  T12: "T12/L1",
  L1: "L1/L2",
  L2: "L2/L3",
  L3: "L3/L4",
  L4: "L4/L5",
  L5: "L5/S1",
});

export const EntityEnum = Object.freeze({
  SACRUM_C: 2000,
  VERTEBRAE_L5_C: 2001,
  VERTEBRAE_L4_C: 2002,
  VERTEBRAE_L3_C: 2003,
  VERTEBRAE_L2_C: 2004,
  VERTEBRAE_L1_C: 2005,
  VERTEBRAE_T12_C: 2006,
  VERTEBRAE_T11_C: 2007,
  VERTEBRAE_T10_C: 2008,
  VERTEBRAE_T9_C: 2009,
  VERTEBRAE_T8_C: 2010,
  VERTEBRAE_T7_C: 2011,
  VERTEBRAE_T6_C: 2012,
  VERTEBRAE_T5_C: 2013,
  VERTEBRAE_T4_C: 2014,
  VERTEBRAE_T3_C: 2015,
  VERTEBRAE_T2_C: 2016,
  VERTEBRAE_T1_C: 2017,
  VERTEBRAE_C7_C: 2018,
  VERTEBRAE_C6_C: 2019,
  VERTEBRAE_C5_C: 2020,
  VERTEBRAE_C4_C: 2021,
  VERTEBRAE_C3_C: 2022,
  VERTEBRAE_C2_C: 2023,
  VERTEBRAE_C1_C: 2024,
  VERTEBRAE_L6_C: 2025,
  VERTEBRAE_T13_C: 2026,
  SACRUM_HL: 2027,
  VERTEBRAE_L5_HL: 2028,
  VERTEBRAE_L4_HL: 2029,
  VERTEBRAE_L3_HL: 2030,
  VERTEBRAE_L2_HL: 2031,
  VERTEBRAE_L1_HL: 2032,
  VERTEBRAE_T12_HL: 2033,
  VERTEBRAE_T11_HL: 2034,
  VERTEBRAE_T10_HL: 2035,
  VERTEBRAE_T9_HL: 2036,
  VERTEBRAE_T8_HL: 2037,
  VERTEBRAE_T7_HL: 2038,
  VERTEBRAE_T6_HL: 2039,
  VERTEBRAE_T5_HL: 2040,
  VERTEBRAE_T4_HL: 2041,
  VERTEBRAE_T3_HL: 2042,
  VERTEBRAE_T2_HL: 2043,
  VERTEBRAE_T1_HL: 2044,
  VERTEBRAE_C7_HL: 2045,
  VERTEBRAE_C6_HL: 2046,
  VERTEBRAE_C5_HL: 2047,
  VERTEBRAE_C4_HL: 2048,
  VERTEBRAE_C3_HL: 2049,
  VERTEBRAE_C2_HL: 2050,
  VERTEBRAE_C1_HL: 2051,
  VERTEBRAE_L6_HL: 2052,
  VERTEBRAE_T13_HL: 2053,
  SACRUM_FL: 2054,
  VERTEBRAE_L5_FL: 2055,
  VERTEBRAE_L4_FL: 2056,
  VERTEBRAE_L3_FL: 2057,
  VERTEBRAE_L2_FL: 2058,
  VERTEBRAE_L1_FL: 2059,
  VERTEBRAE_T12_FL: 2060,
  VERTEBRAE_T11_FL: 2061,
  VERTEBRAE_T10_FL: 2062,
  VERTEBRAE_T9_FL: 2063,
  VERTEBRAE_T8_FL: 2064,
  VERTEBRAE_T7_FL: 2065,
  VERTEBRAE_T6_FL: 2066,
  VERTEBRAE_T5_FL: 2067,
  VERTEBRAE_T4_FL: 2068,
  VERTEBRAE_T3_FL: 2069,
  VERTEBRAE_T2_FL: 2070,
  VERTEBRAE_T1_FL: 2071,
  VERTEBRAE_C7_FL: 2072,
  VERTEBRAE_C6_FL: 2073,
  VERTEBRAE_C5_FL: 2074,
  VERTEBRAE_C4_FL: 2075,
  VERTEBRAE_C3_FL: 2076,
  VERTEBRAE_C2_FL: 2077,
  VERTEBRAE_C1_FL: 2078,
  VERTEBRAE_L6_FL: 2079,
  VERTEBRAE_T13_FL: 2080,
  SACRUM_HR: 2081,
  VERTEBRAE_L5_HR: 2082,
  VERTEBRAE_L4_HR: 2083,
  VERTEBRAE_L3_HR: 2084,
  VERTEBRAE_L2_HR: 2085,
  VERTEBRAE_L1_HR: 2086,
  VERTEBRAE_T12_HR: 2087,
  VERTEBRAE_T11_HR: 2088,
  VERTEBRAE_T10_HR: 2089,
  VERTEBRAE_T9_HR: 2090,
  VERTEBRAE_T8_HR: 2091,
  VERTEBRAE_T7_HR: 2092,
  VERTEBRAE_T6_HR: 2093,
  VERTEBRAE_T5_HR: 2094,
  VERTEBRAE_T4_HR: 2095,
  VERTEBRAE_T3_HR: 2096,
  VERTEBRAE_T2_HR: 2097,
  VERTEBRAE_T1_HR: 2098,
  VERTEBRAE_C7_HR: 2099,
  VERTEBRAE_C6_HR: 2100,
  VERTEBRAE_C5_HR: 2101,
  VERTEBRAE_C4_HR: 2102,
  VERTEBRAE_C3_HR: 2103,
  VERTEBRAE_C2_HR: 2104,
  VERTEBRAE_C1_HR: 2105,
  VERTEBRAE_L6_HR: 2106,
  VERTEBRAE_T13_HR: 2107,
  SACRUM_FR: 2108,
  VERTEBRAE_L5_FR: 2109,
  VERTEBRAE_L4_FR: 2110,
  VERTEBRAE_L3_FR: 2111,
  VERTEBRAE_L2_FR: 2112,
  VERTEBRAE_L1_FR: 2113,
  VERTEBRAE_T12_FR: 2114,
  VERTEBRAE_T11_FR: 2115,
  VERTEBRAE_T10_FR: 2116,
  VERTEBRAE_T9_FR: 2117,
  VERTEBRAE_T8_FR: 2118,
  VERTEBRAE_T7_FR: 2119,
  VERTEBRAE_T6_FR: 2120,
  VERTEBRAE_T5_FR: 2121,
  VERTEBRAE_T4_FR: 2122,
  VERTEBRAE_T3_FR: 2123,
  VERTEBRAE_T2_FR: 2124,
  VERTEBRAE_T1_FR: 2125,
  VERTEBRAE_C7_FR: 2126,
  VERTEBRAE_C6_FR: 2127,
  VERTEBRAE_C5_FR: 2128,
  VERTEBRAE_C4_FR: 2129,
  VERTEBRAE_C3_FR: 2130,
  VERTEBRAE_C2_FR: 2131,
  VERTEBRAE_C1_FR: 2132,
  VERTEBRAE_L6_FR: 2133,
  VERTEBRAE_T13_FR: 2134,
  SACRUM_HA: 2135,
  VERTEBRAE_L5_HA: 2136,
  VERTEBRAE_L4_HA: 2137,
  VERTEBRAE_L3_HA: 2138,
  VERTEBRAE_L2_HA: 2139,
  VERTEBRAE_L1_HA: 2140,
  VERTEBRAE_T12_HA: 2141,
  VERTEBRAE_T11_HA: 2142,
  VERTEBRAE_T10_HA: 2143,
  VERTEBRAE_T9_HA: 2144,
  VERTEBRAE_T8_HA: 2145,
  VERTEBRAE_T7_HA: 2146,
  VERTEBRAE_T6_HA: 2147,
  VERTEBRAE_T5_HA: 2148,
  VERTEBRAE_T4_HA: 2149,
  VERTEBRAE_T3_HA: 2150,
  VERTEBRAE_T2_HA: 2151,
  VERTEBRAE_T1_HA: 2152,
  VERTEBRAE_C7_HA: 2153,
  VERTEBRAE_C6_HA: 2154,
  VERTEBRAE_C5_HA: 2155,
  VERTEBRAE_C4_HA: 2156,
  VERTEBRAE_C3_HA: 2157,
  VERTEBRAE_C2_HA: 2158,
  VERTEBRAE_C1_HA: 2159,
  VERTEBRAE_L6_HA: 2160,
  VERTEBRAE_T13_HA: 2161,
  SACRUM_FA: 2162,
  VERTEBRAE_L5_FA: 2163,
  VERTEBRAE_L4_FA: 2164,
  VERTEBRAE_L3_FA: 2165,
  VERTEBRAE_L2_FA: 2166,
  VERTEBRAE_L1_FA: 2167,
  VERTEBRAE_T12_FA: 2168,
  VERTEBRAE_T11_FA: 2169,
  VERTEBRAE_T10_FA: 2170,
  VERTEBRAE_T9_FA: 2171,
  VERTEBRAE_T8_FA: 2172,
  VERTEBRAE_T7_FA: 2173,
  VERTEBRAE_T6_FA: 2174,
  VERTEBRAE_T5_FA: 2175,
  VERTEBRAE_T4_FA: 2176,
  VERTEBRAE_T3_FA: 2177,
  VERTEBRAE_T2_FA: 2178,
  VERTEBRAE_T1_FA: 2179,
  VERTEBRAE_C7_FA: 2180,
  VERTEBRAE_C6_FA: 2181,
  VERTEBRAE_C5_FA: 2182,
  VERTEBRAE_C4_FA: 2183,
  VERTEBRAE_C3_FA: 2184,
  VERTEBRAE_C2_FA: 2185,
  VERTEBRAE_C1_FA: 2186,
  VERTEBRAE_L6_FA: 2187,
  VERTEBRAE_T13_FA: 2188,
  SACRUM_HP: 2189,
  VERTEBRAE_L5_HP: 2190,
  VERTEBRAE_L4_HP: 2191,
  VERTEBRAE_L3_HP: 2192,
  VERTEBRAE_L2_HP: 2193,
  VERTEBRAE_L1_HP: 2194,
  VERTEBRAE_T12_HP: 2195,
  VERTEBRAE_T11_HP: 2196,
  VERTEBRAE_T10_HP: 2197,
  VERTEBRAE_T9_HP: 2198,
  VERTEBRAE_T8_HP: 2199,
  VERTEBRAE_T7_HP: 2200,
  VERTEBRAE_T6_HP: 2201,
  VERTEBRAE_T5_HP: 2202,
  VERTEBRAE_T4_HP: 2203,
  VERTEBRAE_T3_HP: 2204,
  VERTEBRAE_T2_HP: 2205,
  VERTEBRAE_T1_HP: 2206,
  VERTEBRAE_C7_HP: 2207,
  VERTEBRAE_C6_HP: 2208,
  VERTEBRAE_C5_HP: 2209,
  VERTEBRAE_C4_HP: 2210,
  VERTEBRAE_C3_HP: 2211,
  VERTEBRAE_C2_HP: 2212,
  VERTEBRAE_C1_HP: 2213,
  VERTEBRAE_L6_HP: 2214,
  VERTEBRAE_T13_HP: 2215,
  SACRUM_FP: 2216,
  VERTEBRAE_L5_FP: 2217,
  VERTEBRAE_L4_FP: 2218,
  VERTEBRAE_L3_FP: 2219,
  VERTEBRAE_L2_FP: 2220,
  VERTEBRAE_L1_FP: 2221,
  VERTEBRAE_T12_FP: 2222,
  VERTEBRAE_T11_FP: 2223,
  VERTEBRAE_T10_FP: 2224,
  VERTEBRAE_T9_FP: 2225,
  VERTEBRAE_T8_FP: 2226,
  VERTEBRAE_T7_FP: 2227,
  VERTEBRAE_T6_FP: 2228,
  VERTEBRAE_T5_FP: 2229,
  VERTEBRAE_T4_FP: 2230,
  VERTEBRAE_T3_FP: 2231,
  VERTEBRAE_T2_FP: 2232,
  VERTEBRAE_T1_FP: 2233,
  VERTEBRAE_C7_FP: 2234,
  VERTEBRAE_C6_FP: 2235,
  VERTEBRAE_C5_FP: 2236,
  VERTEBRAE_C4_FP: 2237,
  VERTEBRAE_C3_FP: 2238,
  VERTEBRAE_C2_FP: 2239,
  VERTEBRAE_C1_FP: 2240,
  VERTEBRAE_L6_FP: 2241,
  VERTEBRAE_T13_FP: 2242,
  FEMUR_HEADS_C: 2243,
  FEMUR_HEAD_L: 2244,
  FEMUR_HEAD_R: 2245,
  SACRUM_HC: 2246,
});
